import { useEffect, useRef } from 'react';

const useDidUpdate = (callback, ...deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      callback();
    } else {
      didMount.current = true;
    }
  }, deps);
};

export default useDidUpdate;



// WEBPACK FOOTER //
// ./src/hooks/useDidUpdate.js